import {StudentAbsenceJustificationProposal} from '@model/student-absence-justification-proposal';
import {LegalAbsencesEditionPopupData} from '@shared/legal-absences-edition-popup/legal-absences-edition-popup-data';

export interface ProposalSchoolContext {
  elementarySchool: boolean;
  isAbsenceForDayOffEnabled: boolean;
  yearOfStudyCode: string;
  document: File;
}

export function buildLegalAbsencePopupDataFromProposal(proposal: StudentAbsenceJustificationProposal,
                                                       context: ProposalSchoolContext): LegalAbsencesEditionPopupData {
  return {
    title: `${proposal.studentLastName} ${proposal.studentFirstName}`,
    yearOfStudyCode: context.yearOfStudyCode,
    date: proposal.startDate,
    startDate: proposal.startDate,
    endDate: proposal.endDate,
    remark: proposal.remark,
    document: proposal.documentReferenceId ? context.document : null,
    isAbsenceForDayOffEnabled: context.isAbsenceForDayOffEnabled,
    elementarySchool: context.elementarySchool
  };
}
